module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/6392d7f16ef463fee72810e1570bc886.png";